import React from "react";
import { Award, Gem, Globe } from "lucide-react";
import { globalBrand } from "../mock";

const icons = [Award, Gem, Globe];

export default function GlobalBrand() {
  return (
    <section id="global-brand" className="py-24 lg:py-32 bg-[var(--ink-2)] border-y border-[var(--line)]">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl reveal">
          <p className="eyebrow">{globalBrand.eyebrow}</p>
          <h2 className="mt-5 font-serif-display text-4xl sm:text-5xl font-bold leading-[1.06]">
            From a manufacturer to a{" "}
            <span className="text-gradient-gold">global brand</span> buyers respect
          </h2>
          <p className="mt-6 text-lg font-light leading-relaxed text-[var(--ivory)]/80">
            {globalBrand.lead}
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {globalBrand.points.map((p, i) => {
            const Icon = icons[i % icons.length];
            return (
              <div
                key={p.title}
                className="card-lux rounded-2xl p-8 reveal"
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <div className="w-11 h-11 rounded-xl bg-[var(--gold)]/10 flex items-center justify-center mb-6">
                  <Icon size={20} className="text-[var(--gold)]" />
                </div>
                <h3 className="font-serif-display text-xl font-semibold">{p.title}</h3>
                <p className="mt-3 text-sm text-[var(--muted)] leading-relaxed">{p.body}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 reveal">
          <div className="gold-line mb-8 opacity-60" />
          <p className="font-serif-display text-2xl sm:text-3xl font-semibold leading-snug max-w-3xl">
            {globalBrand.closer}
          </p>
        </div>
      </div>
    </section>
  );
}
